import { render, staticRenderFns } from "./terminatedEmployee.vue?vue&type=template&id=547f9c5a"
import script from "./terminatedEmployee.vue?vue&type=script&lang=js"
export * from "./terminatedEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports